import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="relative w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 border border-background-300 rounded-full text-xs font-medium text-foreground-600 uppercase tracking-wider">
            Product Categories
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mt-4">
            Shop by Category
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            Browse our complete collection across 14 curated categories. Find exactly what you need with fast direct access.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col bg-white rounded-xl border border-background-200 hover:border-primary-200 transition-all duration-300 cursor-pointer overflow-hidden"
            >
              <div className="relative h-40 md:h-48 overflow-hidden bg-background-100">
                <img
                  src={cat.imgSrc}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-2 leading-relaxed">
                  {cat.description}
                </p>
                <span className="mt-3 flex items-center gap-1 text-xs font-semibold text-foreground-400 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  Shop Now
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}